import { nodeGroupIsPopulated } from '../../../../../react/utils/helpers/nodeGroupHelpers';
import { getVariantLandingRoute } from '../../../../../react/components/navigation/context/navigationItems';

// @ngInject
const requireProductDevelopment = ($state, $stateParams, variant) => {
  if (!variant.isProductDevelopment) {
    return $state.go(
      getVariantLandingRoute(variant.isProductDevelopment),
      $stateParams,
      { location: 'replace' },
    );
  }
};

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('variant.overview', {
    controller: 'OverviewController as vm',
    parent: 'variant',
    url: '/overview',
    templateUrl: 'main/article/variant/overview/overview.tpl.html',
    data: { pageTitle: 'Overview' },
    resolve: { productDevelopment: requireProductDevelopment },
  });
};

class OverviewController {
  constructor($rootScope, variant) {
    'ngInject';

    this.variant = variant;
    this.article = variant.article;

    $rootScope.pageTitle = `${this.article.itemCode || ''} - Overview`;

    this.isMatrix = nodeGroupIsPopulated({
      nodeXValues: this.article.nodeXValues,
      nodeYValues: this.article.nodeYValues,
    });
  }
}

angular
  .module('main.article.variant.overview', [])
  .config(config)
  .controller('OverviewController', OverviewController);
